type BuildRequestCodeParams = {
  url: string;
  data: string;
  authorizationKey: string;
};

const buildPythonRequestCode = ({
  url,
  data,
  authorizationKey,
}: BuildRequestCodeParams): string => `import requests
  
url = "${url}"
  
payload = {${data}
}
  
headers = {
    "accept": "application/json",
    "content-type": "application/json",
    "authorization": "${authorizationKey}"
}
  
response = requests.post(url, json=payload, headers=headers)
  
print(response.text)`;

const buildNodeRequestCode = ({
  url,
  data,
  authorizationKey,
}: BuildRequestCodeParams): string => `const response = await fetch("${url}", {
    method: "POST",
    body: {${data}
    },
    headers: {
      "Content-Type": "application/json",
      "Authorization": "${authorizationKey}"
    },
  }
).catch(error => console.log(error));
  
console.log(response)`;

const buildCurlRequestCode = ({
  url,
  data,
  authorizationKey,
}: BuildRequestCodeParams): string => `curl --request 'POST' \\
    --url '${url}' \\
    --header 'Accept: application/json' \\
    --header 'Authorization: ${authorizationKey}' \\
    --header 'Content-Type: application/json' \\
    --data '{${data}
    }'`;

export const requestLanguages = ['cURL', 'Python', 'Node.js'] as const;
export type RequestLanguage = (typeof requestLanguages)[number];

export const requestCodeByLanguageMap: Record<
  RequestLanguage,
  (args: BuildRequestCodeParams) => string
> = {
  Python: buildPythonRequestCode,
  'Node.js': buildNodeRequestCode,
  cURL: buildCurlRequestCode,
} as const;
